import parsePhoneNumber from "libphonenumber-js";

export function formatPhoneNumber(phone: string) {
  const parsed = parsePhoneNumber(phone);
  if (!parsed) {
    return phone;
  }
  return parsed.formatNational();
}
